import React from 'react';
import styled from '@emotion/styled';
import backgroundImage from '@assets/images/opt-in-success/background.svg';
import rcLogoImage from '@assets/images/opt-in-success/recharge-logo.svg';
import { Shop } from '@typings/Shop';
import Waves from '@components/Image/Waves';

interface ShopWithValidity extends Shop {
  isValid: any;
  error: string;
}

const Result = ({ shopifyDomain, logoUrl, name, isValid, error }: ShopWithValidity) => (
  <Wrapper>
    <Logo href="https://rechargepayments.com/rechargesms/">
      <img src={rcLogoImage} alt="Recharge Logo" />
    </Logo>
    <Content>
      <Center>
        {(logoUrl && isValid && (
          <ShopLogo
            href={`https://${shopifyDomain}`}
            title="Store"
            style={{ backgroundImage: `url("${logoUrl}")` }}
          />
        )) || <Waves status={isValid ? 'Online' : 'Offline'} />}
      </Center>
      {(isValid && (
        <SuccessBox>
          Congrats! You've successfully opted-in to {name}{' '}
          <strong>SMS subscription management</strong> powered by RechargeSMS! Be on the lookout for
          a welcome text from us. ⚡️
        </SuccessBox>
      )) || (
        <ErrorBox>
          {(error && error === 'timeout' && <>The link has timed out. Please try again.</>) || (
            <>
              Oops! Looks like something went wrong. Please reach out to customer support.
              <br />
              <br />
              <u>
                <strong>contact@idontknowouremaileither.com</strong>
              </u>
            </>
          )}
        </ErrorBox>
      )}
    </Content>
  </Wrapper>
);

export default Result;

const Wrapper = styled.div`
  background-color: #191d48;
  background-image: url(${backgroundImage});
  background-position: center;
  background-size: cover;
  height: 100vh;
  padding: 20px;
`;

const Logo = styled.a`
  bottom: 20px;
  display: block;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);

  @media (min-width: 768px) {
    left: 20px;
    top: 20px;
    transform: none;
  }
`;

const Content = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
`;

const ShopLogo = styled.a`
  background-color: #fff;
  border-radius: 40px;
  display: block;
  height: 138px;
  margin: 0 auto;
  width: 138px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 90%;
`;

const Center = styled.div`
  margin: 0 auto;
`;

const ContentBox = styled.div`
  font-weight: 600;
  color: #191d48;
  font-size: 20px;
  line-height: 24px;
  margin: 0 auto;
  max-width: 470px;
  padding: 20px 26px;
  border-radius: 30px;
  position: relative;
  text-align: center;

  &:before {
    content: '';
    position: absolute;
    top: -11px;
    left: calc(50% - 18px);
    width: 0;
    border-left: 18px solid transparent;
    border-right: 18px solid transparent;
  }
`;

const SuccessBox = styled(ContentBox)`
  border: 2px solid rgb(23, 204, 157);
  background-color: #ebf9f7;
  &:before {
    border-bottom: 13px solid #ebf9f7;
    border-top: 0 solid #ebf9f7;
    z-index: 3;
  }
  &:after {
    content: '';
    position: absolute;
    top: -13px;
    left: calc(50% - 18px);
    width: 0;
    border-bottom: 13px solid rgb(23, 204, 157);
    border-top: 0 solid rgb(23, 204, 157);
    border-left: 18px solid transparent;
    border-right: 18px solid transparent;
    z-index: 2;
  }
`;

const ErrorBox = styled(ContentBox)`
  background-color: #fff1ee;
  &:before {
    border-bottom: 13px solid #fff1ee;
    border-top: 0 solid #fff1ee;
  }
`;
